import { ModalBase } from "../../../../components/Modals/ModalBase"
import InputForm from "../InputFormV2"

import { useEffect } from "react"
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto"

import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import useUtilsDocs from "../../../../actions/utils-documentos.actions"
import {calculoDeLinea} from '../../../../utils/calculo-otros-documentos'

export default function ModalEditarProductoNC (props: any) {
    const {formProducto, onChangeFormProducto, onClickCerrarModalEditarProducto, onClickActualizarProducto, errors} = props
    const {processOtrosImpuestosCalculo} = useUtilsDocs();

    const {neto, subtotal, iva, otrosImpuestos, total} = calculoDeLinea(formProducto, {
        otrosImpuestosDeLinea: (venta) => processOtrosImpuestosCalculo(props.dteCode, formProducto, venta),
        otrosImpuestosEnTotal: true,
    })

    useEffect(() => {
        if(formProducto.exento){
            onChangeFormProducto('conIva', false)
        }
    }, [formProducto.exento])
    
    useEffect(() => {
        if(formProducto.conIva){
            onChangeFormProducto('exento', false)
        }
    }, [formProducto.conIva])

    const handleActualizarProducto = (e: any) => {
        onClickActualizarProducto(e);
    }

    return (
        <ModalBase>
            <div className="cf-modal-container">
            <label className="cf-section-title">{formProducto.servicioDescuento ? 'Descuento' : (formProducto.servicio ? 'Servicio' : 'Producto')}</label>
                <hr className="separador"/>
                <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>  
                    {
                        !formProducto.servicioDescuento && 
                        (
                            <>
                                <SwitchTipoProductoDTE producto = {!formProducto.servicio} disabled={true} />
                                <InputForm disabled={true} required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/>
                                {!formProducto.exento &&
                                    <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                                }
                            </>   
                        )
                    }
                </div>
                <div className="cf-row-inputs" style={{marginTop: '16px'}}>
                    <InputForm 
                        maxLength = {100}
                        type = 'text'
                        value = {formProducto.descripcion}
                        name = 'descripcion'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = 'Descripción'
                        required
                        label = 'Descripción'
                        error = {errors.descripcion}
                        disabled={!formProducto.servicioDescuento}
                    />
                </div>
                {
                    formProducto.servicioDescuento ? (
                        <>
                            <div style={{paddingTop: '20px'}} className="cf-row-inputs">
                                <InputForm 
                                    maxLength = {15}
                                    type = 'text'
                                    value = {parseFloat(formProducto.precio).toFixed(2)}
                                    name = 'precio'
                                    onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                    placeholder = 'Precio'
                                    required
                                    label = 'Precio'
                                    error = {errors.precio}
                                />
                            </div>
                            <div className="cf-calculos-producto" style={{marginTop: '16px'}}>
                                <div className="w-layout-hflex button-actions">
                                    <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                                    <button className="button" onClick={handleActualizarProducto}>Actualizar</button>
                                </div>
                            </div>
                        </>
                    ) 
                    : (
                        <>
                            <div style={{paddingTop: '20px'}}>
                                <div className={`ef-form-producto-div4`}>
                                <div className='label-input'>
                                <InputForm 
                                    maxLength = {15}
                                    type = 'text'
                                    value = {formProducto.cantidad}
                                    name = 'cantidad'
                                    onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                    placeholder = '0'
                                    required
                                    label = 'Cantidad'
                                    error = {errors.cantidad}
                                />
                                </div>
                                <div className='label-input'>
                                <InputForm 
                                    maxLength = {15}
                                    type = 'text'
                                    value = {parseFloat(formProducto.precio).toFixed(2)}
                                    name = 'precio'
                                    onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                    placeholder = 'Precio'
                                    required
                                    label = 'Precio'
                                    error = {errors.precio}
                                    disabled={true}
                                />
                                </div>
                                <div className='label-input'>
                                <InputForm 
                                    type = 'select'
                                    value = {formProducto.tipoDescuento}
                                    name = 'tipoDesc'
                                    onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}
                                    placeholder = 'Tipo de desc.'
                                    required
                                    label = 'Tipo de desc.'
                                    options = {[{value: 'Porcentaje'}, {value: 'Monto'}]}
                                    keyNameText='value'
                                    keyNameValue='value'
                                    disabled={true}
                                />
                                </div>
                                <div className='label-input'>
                                <InputForm 
                                    maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                                    leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                                    type = 'text'
                                    value = {formProducto.descuento}
                                    name = 'descuento'
                                    onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                    placeholder = 'Descuento'
                                    label = 'Descuento'
                                    error = {errors.descuento}
                                    disabled={true}
                                />
                                </div>
                                </div>
                            </div>
                            <div className="cf-calculos-producto">
                                <table>
                                    <tbody>
                                        <tr className="cf-subtotal">
                                            <td>Valor bruto</td>
                                            <td>{isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Impuesto al Valor Agregado 13%
                                            </td>
                                            <td>{isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Otros impuestos
                                            </td>
                                            <td>{isNaN(otrosImpuestos) ? '$0.00' : otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Subtotal</td>
                                            <td>{isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-total">
                                            <td>Total</td>
                                            <td>{isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="w-layout-hflex button-actions">
                                    <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                                    <button className="button" onClick={handleActualizarProducto}>Actualizar</button>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </ModalBase>
    )
}